import { render, staticRenderFns } from "./comprehensiveReport.vue?vue&type=template&id=6ef6eaa0&scoped=true&"
import script from "./comprehensiveReport.vue?vue&type=script&lang=js&"
export * from "./comprehensiveReport.vue?vue&type=script&lang=js&"
import style0 from "./comprehensiveReport.vue?vue&type=style&index=0&id=6ef6eaa0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef6eaa0",
  null
  
)

export default component.exports